<template>
  <chart-card title="Histórico de Faturamento" filter-button :periodFilter="false" :data="chartData" loader="faturamento" is-currency />
</template>

<script>
import ChartCard from '@/components/ChartCard.vue'
import { colors } from '@/config/colors.js'
export default {
  components: {
    ChartCard,
  },
  props: {
    lista: Array,
  },
  computed: {
    chartData() {
      return {
        labels: [...this.lista.map((obj) => obj['NUM_DIA'])],
        datasets: [
          {
            label: 'Faturamento diário',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            fill: false,
            data: [...this.lista.map((obj) => obj['VAL_FATURAMENTO'])],
          },
        ],
      }
    },
  },
}
</script>
